import { Component } from '@angular/core';
declare var $: any;  // Declare jQuery
@Component({
  selector: 'app-fab',
  templateUrl: './fab.component.html',
  styleUrls: ['./fab.component.css']
})
export class FabComponent {

  ngAfterViewInit(): void {
    setTimeout(()=>{
      $('#carousel2').owlCarousel({
        items:1,
        margin: 20,
        loop: true,
        autoplay: false,
        autoplayTimeout: 2500,
        nav: false,
        dots: true
      });
    },2000)
  
  }
}
